export default function ExperienceList({ experiences }) {
  return (
    <div className="flex flex-col gap-10">
      {experiences.map((exp, index) => (
        <div key={index}>
          {/* Company + period on same line */}
          <div className="flex items-baseline justify-between gap-4 mb-0.5">
            <h4 className="text-base font-semibold text-stone-900">{exp.company}</h4>
            <span className="text-xs font-mono text-stone-400 whitespace-nowrap shrink-0">{exp.period}</span>
          </div>

          {/* Role */}
          <p className="text-sm text-stone-500 italic mb-3">{exp.role}</p>

          {/* Responsibilities */}
          <ul className="flex flex-col gap-1.5">
            {exp.responsibilities.map((item, i) => (
              <li key={i} className="flex gap-3 text-sm text-stone-600 leading-relaxed">
                <span className="text-stone-300 mt-0.5 shrink-0 select-none">→</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>

          {/* Divider between entries */}
          {index < experiences.length - 1 && (
            <hr className="rule mt-10" />
          )}
        </div>
      ))}
    </div>
  );
}
